<template>

  <component :is="el" :label="label" :required="required">

    <el-select
      v-model="formData"
      :disabled="disabled"
      value-key="value"
      :placeholder="placeholder"
      @change="updated">
      <el-option
      v-for="item in selects"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
    </el-select>

  </component>

</template>

<script>

import {backhaulTypeData} from '@/components/Data'

export default {
  name: 'select-backhaul',

  props: {
    label: {
      type: String,
      default: 'Backhaul Type'
    },
    value: {
//      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    },
    helpText: {
      type: String,
      default: null
    },
    noForm: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  },

  data () {
    return {
      formData: this.value,
      selects: backhaulTypeData,
      el: this.noForm ? 'div' : 'el-form-item'
    }
  }

}
</script>



// WEBPACK FOOTER //
// SelectBackhaulType.vue?0157dfd8